<template>
  <v-bottom-sheet v-model="show" :inset="$vuetify.breakpoint.lgAndUp" max-width="650">
    <v-card>
      <v-alert type="success">Aggiunta alla Schermata Home</v-alert>

      <v-alert
        type="info"
        outlined
        icon="mdi-apps-box"
      >Troverai l'App sulla Home Screen oppure nel cassetto delle App</v-alert>

      <v-card-actions>
        <v-img
          alt="Logo"
          class="shrink mx-2"
          contain
          src="@/assets/logo.svg"
          transition="scale-transition"
          width="40"
          height="60"
        />
        <v-spacer></v-spacer>
        <v-btn class="shrink mx-2" href="https://nv1500.web.app/" @click="show = false">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
export default {
  name: "ThanksInstall",
  data: () => ({ show: true })
};
</script>